export const scrollIntoView = (id : string) => {
    const element = document.querySelector(`#${id}`)

    if (!element) return;
    element.scrollIntoView({
        block:'start',
        behavior: 'smooth'
    });
}

export const capatilize = (string : string, ignore : string[] = []) : string => {
    const words = string.split(" ")
    for (let i = 0; i < words.length; i++) {
        if(!ignore.includes(words[i])) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
    }
   return words.join(" ")
}